"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenInfo = exports.Tokens = void 0;
const identity_1 = require("../../../identity");
const utils_1 = require("../../../utils");
exports.Tokens = {
    _namespace_: "tokens",
    async info(param) {
        const data = new Map([[0, identity_1.Address.fromString(param.address).toBuffer()]]);
        const res = await this.call("tokens.info", data);
        const payload = res.getPayload();
        return getTokenInfo(payload);
    },
    async create(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const data = makeTokensCreateData(param);
        const res = await this.call("tokens.create", data, { nonce });
        const payload = res.getPayload();
        return getTokenBasicInfo(payload.get(0));
    },
    async update(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const data = makeTokensUpdateData(param);
        await this.call("tokens.update", data, { nonce });
    },
    async addExtendedInfo(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const data = makeTokensAddExtendedData(param);
        await this.call("tokens.addExtendedInfo", data, { nonce });
    },
    async removeExtendedInfo(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const data = makeTokensRemoveExtendedData(param);
        await this.call("tokens.removeExtendedInfo", data, { nonce });
    },
    async mint(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        return await this.call("tokens.mint", makeTokensMintParam(param), {
            nonce,
        });
    },
    async burn(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        return await this.call("tokens.burn", makeTokensBurnParam(param), {
            nonce,
        });
    },
};
// Make maps from objects
function makeTokensCreateData(param) {
    const data = new Map();
    const distribution = new Map();
    if (param.distribution) {
        Object.entries(param.distribution).forEach(([address, amount]) => {
            distribution.set(identity_1.Address.fromString(address).toBuffer(), amount);
        });
    }
    data.set(0, makeTokenInfoSummary(param.summary));
    param.owner && data.set(1, identity_1.Address.fromString(param.owner).toBuffer());
    param.distribution && data.set(2, param.distribution);
    param.maximumSupply && data.set(3, param.maximumSupply);
    param.extended && data.set(4, param.extended);
    return data;
}
function makeTokensUpdateData(param) {
    const data = new Map();
    data.set(0, param.address);
    param.name && data.set(1, param.name);
    param.symbol && data.set(2, param.symbol);
    param.precision && data.set(3, param.precision);
    param.owner && data.set(4, identity_1.Address.fromString(param.owner).toBuffer());
    param.memo && data.set(5, param.memo);
    return data;
}
function makeTokenInfoSummary(param) {
    const data = new Map();
    data.set(0, param.name);
    data.set(1, param.symbol);
    data.set(2, param.precision);
    return data;
}
function makeTokensAddExtendedData(param) {
    const data = new Map();
    data.set(0, param.address);
    data.set(1, param.extended);
    return data;
}
function makeTokensRemoveExtendedData(param) {
    const data = new Map();
    data.set(0, param.address);
    data.set(1, param.indices);
    return data;
}
function makeTokensMintParam(param) {
    const data = new Map();
    data.set(0, param.symbol);
    data.set(1, new Map(Object.entries(param.addresses)));
    return data;
}
function makeTokensBurnParam(param) {
    const data = new Map();
    data.set(0, param.symbol);
    data.set(1, new Map(Object.entries(param.addresses)));
    data.set(3, true);
    return data;
}
// Get objects from maps
function getTokenInfo(data) {
    const result = {
        info: getTokenBasicInfo(data.get(0)),
    };
    data.get(1) && (result.extended = data.get(1));
    return result;
}
exports.getTokenInfo = getTokenInfo;
function getTokenBasicInfo(data) {
    const result = {
        address: data.get(0),
        summary: getTokenInfoSummary(data.get(1)),
        supply: getTokenInfoSupply(data.get(2)),
    };
    data.get(3) && (result.owner = data.get(3));
    return result;
}
function getTokenInfoSummary(data) {
    return {
        name: data.get(0),
        symbol: data.get(1),
        precision: data.get(2),
    };
}
function getTokenInfoSupply(data) {
    const result = {
        total: data.get(0),
        circulating: data.get(1),
    };
    data.get(2) && (result.maximum = data.get(2));
    return result;
}
